<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Director's Benefits - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div class="row mb-3">
          <div class="col-12">
            <p class="text-dark">Please enter notes on Director's benefits in the field below.</p>
            <p class="text-dark">
              If you do not have any notes to make, please return to the notes menu and de-select this section.
            </p>
          </div>
        </div>
        <form [formGroup]="benfitform">
          <div class="row mb-5">
            <div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <label class="mb-2">
                Please enter any additional information in the field below.
              </label>
              <div class="mb-3">
                <textarea class="form-control allowSpecialChars" appNumberdirective rows="6" formControlName="TextComment" maxlength="4000"></textarea>
              </div>
            </div>
          </div>
        </form>
        
        <div class="row">
          <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
            <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)=" back()">Back</button>
            <button type="button" class="btn  themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
          </div>
        </div>
      </div>

      </div>
    </div>
  </div>
